import React, { useState } from 'react';
import styles from '../AdminPanel.module.css';
import { MdNotificationsActive, MdInfoOutline } from 'react-icons/md';

interface AnnouncementsProps {
  onCreateAnnouncement: (data: any) => Promise<void>;
}

const Announcements: React.FC<AnnouncementsProps> = ({ onCreateAnnouncement }) => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [importance, setImportance] = useState<'low' | 'medium' | 'high'>('medium');
  const [targetRoles, setTargetRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const handleRoleChange = (role: string) => {
    if (targetRoles.includes(role)) {
      setTargetRoles(targetRoles.filter(r => r !== role));
    } else {
      setTargetRoles([...targetRoles, role]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!title || !message || !startDate || !endDate) {
      alert('Lütfen tüm zorunlu alanları doldurun.');
      return;
    }
    
    setLoading(true);
    
    try {
      await onCreateAnnouncement({
        title,
        message,
        startDate,
        endDate,
        importance,
        targetUserRoles: targetRoles.length > 0 ? targetRoles : undefined
      });
      
      // Form alanlarını temizle
      setTitle('');
      setMessage('');
      setStartDate('');
      setEndDate('');
      setImportance('medium');
      setTargetRoles([]);
      
    } catch (error) {
      console.error("Duyuru oluşturulurken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Sistem Duyuruları</h2>
      
      <div className={styles.cardSection}>
        <h3>Yeni Duyuru Oluştur</h3>
        
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Duyuru Başlığı *</label>
            <input 
              type="text"
              className={styles.formInput}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Duyuru başlığını girin"
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Duyuru Metni *</label>
            <textarea 
              className={styles.formTextarea}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Duyuru içeriğini girin"
              required
            />
          </div>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup} style={{ flex: 1 }}>
              <label className={styles.formLabel}>Başlangıç Tarihi *</label>
              <input 
                type="datetime-local"
                className={styles.formInput}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>
            
            <div className={styles.formGroup} style={{ flex: 1 }}>
              <label className={styles.formLabel}>Bitiş Tarihi *</label>
              <input 
                type="datetime-local"
                className={styles.formInput}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </div>
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Önem Seviyesi</label>
            <select 
              className={styles.formSelect}
              value={importance}
              onChange={(e) => setImportance(e.target.value as any)}
            >
              <option value="low">Düşük</option>
              <option value="medium">Orta</option>
              <option value="high">Yüksek</option>
            </select>
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Hedef Kullanıcı Rolleri</label>
            <div className={styles.checkboxGroup}>
              <label className={styles.checkboxLabel}>
                <input 
                  type="checkbox"
                  checked={targetRoles.includes('user')}
                  onChange={() => handleRoleChange('user')}
                />
                Standart Kullanıcılar
              </label>
              
              <label className={styles.checkboxLabel}>
                <input 
                  type="checkbox"
                  checked={targetRoles.includes('premium')}
                  onChange={() => handleRoleChange('premium')}
                />
                Premium Kullanıcılar
              </label>
              
              <label className={styles.checkboxLabel}>
                <input 
                  type="checkbox"
                  checked={targetRoles.includes('admin')}
                  onChange={() => handleRoleChange('admin')}
                />
                Yöneticiler
              </label>
            </div>
            <p className={styles.formHint}>
              <MdInfoOutline /> Hiçbir rol seçilmezse, duyuru tüm kullanıcılara gösterilir.
            </p>
          </div>
          
          <div className={styles.formActions}>
            <button 
              type="submit" 
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'Oluşturuluyor...' : 'Duyuru Oluştur'}
            </button>
          </div>
        </form>
      </div>
      
      <div className={styles.cardSection}>
        <div className={styles.infoBox}>
          <MdNotificationsActive className={styles.infoIcon} />
          <div>
            <h4>Duyurular Hakkında</h4>
            <p>Sistem duyuruları, kullanıcılara önemli bilgileri iletmek için kullanılır. 
              Bu duyurular, uygulama içinde bildirim olarak gösterilir ve belirtilen tarih aralığında aktif kalır.</p>
            <p>Duyurular kullanıcı rollerine ve şehirlere göre hedeflenebilir. 
              Ayrıca önem seviyelerine göre farklı şekillerde vurgulanır.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcements;
